// extracted by mini-css-extract-plugin
module.exports = {"richText":"RichText_richText__Ck8I8"};